import React from 'react';

import HeaderSection from '../../components/HeaderSection';
import FooterSection from '../../components/FooterSection';
import QuestionsSection from '../../components/QuestionsSection';
import BannerSection from '../../components/BannerSection';
import FaqSection from '../../components/FaqSection';
import TimelineSection from '../../components/TimelineSection';
import WhatsAppFab from '../../components/WhatsAppFab';

function Home() {
  return (
    <>
      <HeaderSection />
      <FaqSection />
      <QuestionsSection />
      <BannerSection />
      <TimelineSection />
      <FooterSection />
      <WhatsAppFab />
    </>
  );
}

export default Home;
